<app-modal-header [title]="data.title" />

<app-modal-body>
  <div class="date-sheet">
    <div class="cal-header">
      <button type="button" class="cal-nav" aria-label="Previous month" (click)="prevMonth()">&#8249;</button>
      <span class="cal-month">{{ MONTH_NAMES[month] }} {{ year }}</span>
      <button type="button" class="cal-nav" aria-label="Next month" (click)="nextMonth()">&#8250;</button>
    </div>
    <div class="cal-grid">
      @for (d of DAY_NAMES; track d) {
        <div class="cal-dow">{{ d }}</div>
      }
      @for (day of days; track $index) {
        <button
          type="button"
          class="cal-day"
          [class.cal-day--selected]="isSelected(day)"
          [class.cal-day--today]="isToday(day)"
          [class.cal-day--empty]="!day"
          [disabled]="!day"
          (click)="pick(day)"
        >{{ day || '' }}</button>
      }
    </div>
  </div>
</app-modal-body>

<app-modal-footer>
  <button type="button" class="btn--secondary" [disabled]="!data.selected" (click)="modalRef.close(null)">Clear date</button>
</app-modal-footer>
